import { Property } from '@/types/property';
import PropertyDisplay from './PropertyDisplay';

interface ListingCardProps {
  property: Property;
  onNavigate: () => void;
}

export default function PropertiesMapPopup({ property, onNavigate }: ListingCardProps) {
  return (
    <PropertyDisplay
      property={property}
      variant="popup"
      onClick={onNavigate}
      buttonText="View Details"
      showButton={true}
    />
  );
}